import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import AvailabilityBooking from './AvailabilityBooking'
import AvailabilityCategory from './AvailabilityCategory'

import { selectUserData } from '../../../../../routing/fetchingfunction/user/user.reducer'

const Availability = () => {
  const userData = useSelector(selectUserData)

  const [advanceBooking, setAdvanceBooking] = useState(
    userData?.calendar_settings?.advance_booking || ''
  )
  const [repeatWeekly, setRepeatWeekly] = useState(
    userData?.calendar_settings?.repeat_weekly || false
  )
  const [advanceBookingErrors, setAdvanceBookingErrors] = useState(null)

  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-[10px] bg-[#FEEBDD] text-primary-100 p-[20px]">
        Availability Settings
      </h3>

      <AvailabilityCategory
        advanceBooking={advanceBooking}
        repeatWeekly={repeatWeekly}
        onAdvanceErrorChange={setAdvanceBookingErrors}
      />

      <AvailabilityBooking
        advanceBooking={advanceBooking}
        repeatWeekly={repeatWeekly}
        setAdvanceBooking={setAdvanceBooking}
        setRepeatWeekly={setRepeatWeekly}
        advanceBookingErrors={advanceBookingErrors}
        onAdvanceErrorChange={setAdvanceBookingErrors}
      />
    </div>
  )
}

export default Availability
